import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function() {
    const { response: { products }, loading, } = useAppState()

    useEffect(() => {
        if(typeof window.Nosto?.migrateToShopifyMarket === 'function') {
            window.Nosto.migrateToShopifyMarket({
                productSectionElement: '.ns-product-card',
                productHandleAttribute: 'data-handle',
                productUrlElement: '.product-link',

                productTitleElement: '.product-title-link',
                priceElement: '.price-container > .final-price',
                listPriceElement: '.price-container > .compare-price',
          })
        }
    }, [ products ])

    useEffect(() => {
        if(!window.nostojs) return;
        window.nostojs(api =>{
            api.loadRecommendations({ skipPageViews: true, skipEvents: true })
        })
        return () => document.querySelectorAll('#ns-product-grid .nosto_element').forEach(el => el.remove());
    }, [ products.hits ])

    return (
        <div class="relative">
            <div
                id="ns-product-grid"
                class="grid grid-cols-2 gap-y-6 gap-x-6 px-4 lg:px-0 md:grid-cols-2 md:gap-x-2 md:gap-y-[80px] lg:grid-cols-4 lg:gap-x-[30px] !ml-0"
                style={loading ? "opacity: 0.3;" : ""}
            >
                {products.hits.map((hit, index) => (
                    <Product product={hit} index={index} key={hit.productId || index} />
                ))}
            </div>
        </div>
    )
}
